import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'icp-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent {
  @Input() name?: string;
  @Input() src?: string;
  @Input() basePath: string = '/assets/icons';
  @Input() size: number | string = 20;
  @Input() width?: number | string;
  @Input() height?: number | string;
  @Input() color?: string;
  @Input() title?: string;
  @Input() inline = true;
  @Input() mask?: boolean;

  get url(): string | null {
    if (this.src) return this.src;
    if (this.name) return `${this.basePath}/${this.name}.svg`;
    return null;
  }

  get pxSize(): string {
    return typeof this.size === 'number' ? `${this.size}px` : this.size || '20px';
  }

  get pxWidth(): string {
    if (this.width !== undefined) {
      return typeof this.width === 'number' ? `${this.width}px` : this.width;
    }
    return this.pxSize;
  }

  get pxHeight(): string {
    if (this.height !== undefined) {
      return typeof this.height === 'number' ? `${this.height}px` : this.height;
    }
    return this.pxSize;
  }

  get useMask(): boolean {
    if (!this.url) return false;
    if (this.mask !== undefined) return !!this.mask;
    const u = this.url.toLowerCase();
    return (
      u.endsWith('.svg') || u.includes('.svg?') || u.startsWith('data:image/svg+xml')
    );
  }

  get cssMaskUrl(): string | null {
    if (!this.url) return null;

    const escaped = this.url.replace(/"/g, '\\"');
    return `url("${escaped}")`;
  }
}
